// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pGZ8W","label":"styles_label__3t0vP"};